import {
  Blockquote,
  Group,
  Paper,
  TagsInput,
  Text,
} from "@mantine/core";
import { IconTags } from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";

const ResellersDefaultTags = ({ tags, setTags }) => {
  const lang = useLanguage((s) => s.language);

  return (
    <Paper p={"md"} gap={"xl"} px={"xl"}>
      <Group>
        <IconTags />
        <Text size="xl" fw={700}>
          {lang.resellers.tags.title}
        </Text>
      </Group>

      <Blockquote p={"sm"} my={16} radius={"md"}>
        <Text size="lg">{lang.resellers.tags.text}</Text>
      </Blockquote>

      <TagsInput
        description={lang.resellers.tags.desc}
        placeholder={lang.resellers.tags.placeholder}
        value={tags}
        onChange={setTags}
        size="lg"
      />
    </Paper>
  );
};

export default ResellersDefaultTags;
